import { is18YearsOldDateValue } from '../helpers/date';
import { FormData } from '../types';

const VALUES_TO_TRANSLATE = {
  label: '',
  placeholder: '',
};

export const landingFormData: FormData = {
  nif: {
    type: 'textInput',
    name: 'nif',
    ...VALUES_TO_TRANSLATE,
    value: '',
    validations: [
      {
        type: 'required',
      },
      {
        type: 'matchesNIFNIE',
      },
    ],
  },
  userName: {
    type: 'textInput',
    name: 'userName',
    ...VALUES_TO_TRANSLATE,
    value: '',
    validations: [
      {
        type: 'required',
      },
      {
        type: 'minLength',
        value: 2,
      },
      {
        type: 'maxLength',
        value: 100,
      },
      {
        type: 'matchesAlphabetic',
      },
    ],
  },
  address: {
    type: 'textInput',
    name: 'address',
    ...VALUES_TO_TRANSLATE,
    value: '',
    validations: [
      {
        type: 'required',
      },
      {
        type: 'minLength',
        value: 2,
      },
      {
        type: 'maxLength',
      },
      {
        type: 'matchesAlphanumeric',
      },
    ],
  },
  town: {
    type: 'textInput',
    name: 'town',
    ...VALUES_TO_TRANSLATE,
    value: '',
    validations: [
      {
        type: 'required',
      },
      {
        type: 'minLength',
        value: 2,
      },
      {
        type: 'maxLength',
        value: 50,
      },
      {
        type: 'matchesAlphabetic',
      },
    ],
  },
  birthDate: {
    type: 'date',
    name: 'birthDate',
    ...VALUES_TO_TRANSLATE,
    value: '',
    validations: [
      {
        type: 'required',
      },
      {
        type: 'minDate',
        value: '01/01/1910',
      },
      {
        type: 'maxDate',
        value: is18YearsOldDateValue(),
      },
    ],
  },
};
